/* Product Tile Markup - You can play around with this to change the
information that appears on the Wishlisted Product tiles  */

var productCardMarkup = `
    <div class="swym-wishlist-grid">
     {{#products}} 
       <div class="swym-wishlist-item swym-is-anchorc col_slide">
         <button id="swym-remove-productBtn" aria-label="Delete" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="swym-delete-btn swym-nav swym-nav-1 swym-is-button">
           <span class="swym-icon">
           </span>
         </button>
         <div class="swym-wishlist-image-wrapper">
           <a href="{{du}}">
             <img alt="" class="swym-wishlist-image" src="{{iu}}">
           </a>
         </div>
         <button class="swym-is-button">
           <div class="swym-title swym-title-1">
             <a href="{{du}}">
             {{dt}}
             </a>
           </div>
         </button>
         <div class="swym-variant-title swym-text swym-title-2 swym-variant-title-spacer">
           {{variantinfo}}
         </div>
         <div class="swym-product-price swym-text swym-text-1">
           <div class="swym-product-final-price swym-value">
             {{cu}}{{pr}}
           </div>
         </div>
         <div class="buttons_and_variants">
           <button id="swym-custom-add-toCartBtn" data-state-cart="{{#isInCart}} swym-added{{/isInCart}}" data-product-url="{{du}}" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="swym-add-to-cart-btn swym-button swym-button-1 swym-is-button swym-is-button">
             {{#isInCart}}<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
<circle cx="7.5" cy="7.5" r="7.5" fill="#72BE4E"/>
<line x1="4.37522" y1="7.25271" x2="7.14216" y2="10.0197" stroke="white" stroke-width="1.30435"/>
<line x1="6.21853" y1="10.02" x2="10.8301" y2="5.40848" stroke="white" stroke-width="1.30435"/>
</svg><span>Added to cart</span>{{/isInCart}}{{^isInCart}}Add to cart{{/isInCart}}
           </button>
           <div class="favrt-btm">
              <div class="selector_btn">
                <button class="change-variant change-variant-btn" data-product-id="{{empi}}" data-url="{{du}}" data-variant-id="{{epi}}" data-variant-name="{{vi}}">
                  <span>{{vi}}</span>
                  <span><svg xmlns="http://www.w3.org/2000/svg" width="11" height="6" viewBox="0 0 11 6" fill="none"><path d="M10.89 6C9.13 4.6 6.16 3.1 5.5 2.6C4.84 3.1 1.87 4.6 0.11 6L1.19249e-09 5.9C1.76 4.5 5.28 0.199999 5.5 -8.88087e-07C5.72 0.199999 9.24 4.5 11 5.9L10.89 6Z" fill="#050505"/></svg></span>
                </button>
              </div>
              <div class="swymmodal-overlay">&nbsp;</div>
          </div>
        </div>
       </div>
     {{/products}}
  </div>`;

var variantModalMarkUp = `
    <div class="wishlist-sizedrawer" id="modal">
      <div class="modal-guts">
        {{#product.options}}
          <div class="select-variant-{{name}}" id="user-options-{{name}}">
            {{#values}}
              <div class="sywm-radio">
                <input type="radio" name="{{name}}" data-value="{{.}}" id="user-option{{.}}">
                <label for="user-option{{.}}">{{.}}<span class="favourite-dots"></span></label>
              </div>
            {{/values}}
          </div> 
          {{}}
        {{/product.options}}
      </div>      
    </div>`;

function getVariantInfo(variants) {
	try {
		let variantKeys = ((variants && variants != "[]") ? Object.keys(JSON.parse(variants)[0]) : []),
			variantinfo;
		if (variantKeys.length > 0) {
			variantinfo = variantKeys[0];
			if (variantinfo == "Default Title") {
				variantinfo = "";
			}
		} else {
			variantinfo = "";
		}
		return variantinfo;
	} catch (err) {
		return variants;
	}
}

function onAddToCartClick(e) {
	e.preventDefault();
	var productId = e.currentTarget.getAttribute("data-product-id");
	var variantId = e.currentTarget.getAttribute("data-variant-id");
	var du = e.target.getAttribute("data-product-url");
	e.target.innerHTML = "Adding..";
	window._swat.replayAddToCart({
		empi: productId,
		du: du
	}, variantId, function(c) {
      var htmltag = `<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                      <circle cx="7.5" cy="7.5" r="7.5" fill="#72BE4E"/>
                      <line x1="4.37522" y1="7.25271" x2="7.14216" y2="10.0197" stroke="white" stroke-width="1.30435"/>
                      <line x1="6.21853" y1="10.02" x2="10.8301" y2="5.40848" stroke="white" stroke-width="1.30435"/>
                      </svg><span>Added to cart</span>`;
		e.target.innerHTML = htmltag;
		e.target.setAttribute("data-state-cart", "swym-added");
        cartNotification(variantId);
        load_cart();
        $('.snippet-product-grid').removeClass('active');
      $('body').removeClass('mobile-gridvariants');
		console.log("Successfully added product to cart.", c);
	}, function(e) {
		console.log(e);
	});
}

function onRemoveBtnClick(e) {
	e.preventDefault();
	var epi = +e.currentTarget.getAttribute("data-variant-id");
	var empi = +e.currentTarget.getAttribute("data-product-id");
	window._swat.fetch(function(products) {
		products.forEach(function(product) {
			if (epi && empi && product.epi == epi && product.empi == empi){
				window._swat.removeFromWishList(product, function() {
					if (!window.SwymCallbacks) {
						window.SwymCallbacks = [];
					}
					window.SwymCallbacks.push(swymRenderWishlist);
				});
			}
		});
	})
}

function swymRenderWishlist(swat) {
	// Get wishlist items
	swat.fetch(function(products) {
		console.log(products)
		var wishlistContentsContainer = document.getElementById("wishlist-items-container");
		var formattedWishlistedProducts = products.map(function(p) {
			p = SwymUtils.formatProductPrice(p); // formats product price and adds currency to product Object
			p.isInCart = _swat.platform.isInDeviceCart(p.epi) || (p.et == _swat.EventTypes.addToCart);
			p.variantinfo = (p.vi ? getVariantInfo(p.vi) : "");
            if(p.vi.includes("/")){
              p.vi = p.vi.split("/")[0];  
            }else if(p.vi.includes(" ")){
              p.vi = p.vi.split(" ")[0];  
            }
			return p;
		});
		var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {
			products: formattedWishlistedProducts
		});
		if(wishlistContentsContainer){
			wishlistContentsContainer.innerHTML = productCardsMarkup;
			attachClickListeners();
		} else{
		  console.log("Container not found, Wishlist Page element not found");
		}
	});
}

function attachClickListeners() {
	var editVariantBtns = document.getElementsByClassName("change-variant-btn");
    for (var i = 0; i < editVariantBtns.length; i++) {
      editVariantBtns[i].addEventListener('click', openVariantSelectionPopUp, false);
    }
    var addToCartButtons = document.querySelectorAll("#swym-custom-add-toCartBtn");
	var removeBtns = document.querySelectorAll("#swym-remove-productBtn");;
	//   Add to cart Btns
	for (var i = 0; i < addToCartButtons.length; i++) {
		addToCartButtons[i].addEventListener('click', onAddToCartClick, false);
	}
	//   Remove Buttons
	for (var k = 0; k < removeBtns.length; k++) {
		removeBtns[k].addEventListener('click', onRemoveBtnClick, false);
	}
	console.log("Events attached!");
}
function countWishlist(){
  window._swat.fetch(function(r) {
    $('.favourite-count').html(r.length+' items');
  });
}
function openVariantSelectionPopUp(e) {
    completeProductJson = {};
    console.log(e.target)
    var productId = e.target.parentElement.getAttribute("data-product-id");
    var variantId = e.target.parentElement.getAttribute("data-variant-id");
    var variantTitle = e.target.parentElement.getAttribute("data-variant-name");
    var du = e.target.parentElement.getAttribute("data-url");
    var params = {
      du: du,
      empi: parseInt(productId),
      epi: parseInt(variantId)
    };
  // debugger
  // const getSiblings = node => Array.from(node.children).filter(c => c !== node)
  // console.log("getSiblings-->",getSiblings)
  // const siblingsToC = getSiblings(e.target.closest('.col_slide'))  
    
    if(e.target.parentElement.closest('.col_slide').classList.contains("active")){
      e.target.parentElement.closest('.col_slide').classList.remove("active");
    }else{
      document.querySelectorAll(".col_slide").forEach(function(e){
        e.classList.remove("active");
      });
      e.target.parentElement.closest('.col_slide').classList.add("active");
    }
    
  
    variantButtonAttributes = {};
    variantButtonAttributes = params; 
    window._swat.getProductDetails(params, function(productJson) { 
    console.log("productJson-->",productJson)
  	completeProductJson = productJson;
      productJson.du = du;
      renderModalUI(productJson);
      var jsonvariantid = productJson.variants;
      jsonvariantid.forEach(function(i,value){ 
        console.log("i-->",i,i.available)
        if (i.available == false){
          console.log("not availabel")
          $('.sywm-radio [data-value="'+i.option1+'"]').prop('disabled',true);
        }
        var allvarName = i.title;
        console.log("allvarName-->",i.option1,variantTitle)
        if(i.option1 == variantTitle){
          $('.sywm-radio [data-value="'+i.option1+'"]').prop('checked',true);
          if(i.available==false){
            $('.mob-buttoncart').hide();
            $('.soldout-gray').show();
          }
        }
      });
    }); 
   // renderWishlistUI();
    countWishlist();
    attachClickListeners();
}
function renderModalUI(productJson) {
  var modalElem = document.querySelector('.col_slide.active .swymmodal-overlay');
  var variantMarkUpTemplate = SwymUtils.renderTemplateString(variantModalMarkUp, {
    product: productJson
  });
  modalElem.innerHTML = variantMarkUpTemplate;
  attachModalEventListeners();
}
function attachModalEventListeners() {
  var saveButtons = document.querySelectorAll(".sywm-radio>input");
  for (var i = 0; i < saveButtons.length; i++) {
    saveButtons[i].addEventListener("click", function(e){
      saveSelection();
      this.closest('.sywm-radio').classList.add('active');     
    });
  }
}
function saveSelection() {
  var userSelectionData = getSelectTagValues("#user-options-Size");
  var variant = findVariant(userSelectionData);
  console.log('variant')
  console.log(variant)
  console.log('variant')
  removeProductFromWishlist(variantButtonAttributes, function(removedProduct) {
    var newProductVariantAttributes = {
      empi: removedProduct.empi,
      epi: variant.id,
      du: removedProduct.du
    }
    addProductToWishlist(newProductVariantAttributes);
  });
}
function getSelectTagValues(selector) {
  var userSelection = {};
  if (typeof selector !== "undefined") {
    var elemNode = document.querySelectorAll(selector);
    $(elemNode).each(function(e){
      var optionValue = $(this).find('input[type="radio"]:checked').data('value');
      if(optionValue != undefined){
        var key = "option" + (e + 1);      
        var selectedValueObj = _defineProperty({}, key, optionValue.toString());
        if (SwymUtils){
          SwymUtils.extendDefaults(userSelection, selectedValueObj);
        }
      }
    });       
    return userSelection;
  } else {
    console.log("Invalid Option Selector");
  }
}
function _defineProperty(obj, key, value) {
  console.log("value------------>",value)
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function findVariant(userSelectedOption) {
  var keys = Object.keys(userSelectedOption).filter(function(key) {
    return userSelectedOption[key] !== null && userSelectedOption[key] !== undefined;
  });

  var match = completeProductJson.variants.find(function(variant) {
    return keys.every(function(key, value) {
      return (variant[key] === userSelectedOption[key] && variant[value] === userSelectedOption[value]);
    });
  });
  return match;
}
  function removeProductFromWishlist(old_product_variant, callback){
    window._swat.removeFromWishList(old_product_variant, function(r){
      callback(r);
    });
  }
  function addProductToWishlist(new_product_variant){
    window._swat.addToWishList(new_product_variant, function(r){
      renderWishlistUI();
    });
  }

function renderWishlistUI() {
  _swat.fetch(function(products) {
    WishlistedProducts = JSON.parse(JSON.stringify(products));
    for(let i = 0; i < WishlistedProducts.length; i++) {
      _swat.getProductDetails({
        du: WishlistedProducts[i].du,
        epi: WishlistedProducts[i].epi,
        empi: WishlistedProducts[i].empi
      },
      function(fullProductDetails) {
        for(let j = 0; j < fullProductDetails.variants.length; j++) {
          if(fullProductDetails.variants[j].id == WishlistedProducts[i].epi) {
            WishlistedProducts[i].available = fullProductDetails.variants[j].available;
          }
        } 
      });
    }
    setTimeout(function(e){      
      $('.swym-wishlist-image').each(function(e){        
        var this_imgsrc = $(this).attr('src');
        var new_src = this_imgsrc.replace('_620x620', '');
        $(this).attr('src',new_src);
      });
      var h3height = 0;
      $('.wrappr_tl_prc').each(function() {
        if(h3height < $(this).outerHeight()){
          h3height = $(this).outerHeight();
        };
      });
      $('.wrappr_tl_prc').height(h3height);
      
    },2000); 
    currentUserWishlist = [];
    var wishlistContentsContainer = document.getElementById("wishlist-items-container");
    currentUserWishlist = products;
    var formattedWishlistedProducts = WishlistedProducts.map(function(p) {
      p = SwymUtils.formatProductPrice(p); // formats product price and adds currency to product Object
      p.variantinfo = (p.variants ? getVariantInfo(p.variants) : "");
      p.isInCart = _swat.platform.isInDeviceCart(p.epi) || (p.et == _swat.EventTypes.addToCart);
      if(p.vi.includes("/")){
        p.vi = p.vi.split("/")[0];  
      }else if(p.vi.includes(" ")){
        p.vi = p.vi.split(" ")[0];  
      }
      
      //p.available = !_swat.platform.isEpiOOS(p.epi);
      return p;
    });
    var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {
      products: WishlistedProducts
    });
    wishlistContentsContainer.innerHTML = productCardsMarkup;
    attachClickListeners();
       
  });
}

if (!window.SwymCallbacks) {
	window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymRenderWishlist); /* Init Here */